import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import type { PageContext } from '@/types';

export const useUserStore = defineStore('user', () => {
  const jwt = ref('');
  const domain = ref('');
  const user = ref('');
  const username = ref('');
  const serverType = ref('');
  const wssUrl = ref('');
  const nsApiUrl = ref('');
  const nsApiV1Url = ref('');
  const installId = ref('');
  const showReports = ref(false);

  const isAuthenticated = computed(() => !!jwt.value);

  function initialize(ctx: PageContext) {
    jwt.value = ctx.jwt;
    domain.value = ctx.domain;
    user.value = ctx.user;
    username.value = ctx.username;
    serverType.value = ctx.serverType;
    wssUrl.value = ctx.wssUrl;
    nsApiUrl.value = ctx.nsApiUrl;
    nsApiV1Url.value = ctx.nsApiV1Url;
    installId.value = ctx.installId;
    showReports.value = ctx.showReports;
  }

  function updateToken(newJwt: string) {
    jwt.value = newJwt;
  }

  return {
    jwt,
    domain,
    user,
    username,
    serverType,
    wssUrl,
    nsApiUrl,
    nsApiV1Url,
    installId,
    showReports,
    isAuthenticated,
    initialize,
    updateToken,
  };
});
